import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { toast, ToastContainer } from "react-toastify";

const ReceiveableFeePrint = () => {
    const [AccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID] = useState(localStorage.getItem("ID"));
    const [MemberType] = useState(localStorage.getItem("MemberType"));
    const [loading, setLoading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [StartDate, setStartDate] = useState("");
    const [EndDate, setEndDate] = useState("");
    const [ShowReceivedFee, setShowReceivedFee] = useState(false);
    const [TotalFeeAmount, setTotalFeeAmount] = useState(0);
    const [FeeTypeName, setFeeTypeName] = useState("");

    const amountLabel = ShowReceivedFee ? "Received Fee" : "Receivable Fee";
    const dateColumnLabel = ShowReceivedFee ? "Received Date" : "Posting Date";

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const startDate = urlParams.get("StartDate") || "";
        const endDate = urlParams.get("EndDate") || "";
        const wingId = parseInt(urlParams.get("Wing_Id"), 10) || 0;
        const feetype = parseInt(urlParams.get("FeeTypeId"), 10) || 0;
        const classId = parseInt(urlParams.get("Class_Id"), 10) || 0;
        const sectionId = parseInt(urlParams.get("Section_Id"), 10) || 0;
        const showReceived =
            urlParams.get("ShowReceivedFee") === "1" ||
            urlParams.get("ShowReceivedFee") === "true";

        setStartDate(startDate);
        setEndDate(endDate);
        setShowReceivedFee(showReceived);
        document.title = showReceived ? "Received Fee Report" : "Receivable Fee Report";

        if (!startDate || !endDate) {
            toast.error("Start date and end date are required.");
            setLoading(false);
            return;
        }
        if (!feetype) {
            toast.error("Fee head is required.");
            setLoading(false);
            return;
        }

        setLoading(true);

        const data = {
            AccessKey,
            UserID,
            MemberType,
            pageNo: 1,
            pageSize: 10000000,
            StartDate: startDate,
            EndDate: endDate,
            ShowReceivedFee: showReceived,
            Wing_Id: wingId,
            FeeTypeId: feetype,
            Class_Id: classId,
            Section_Id: sectionId,
        };

        axios({
            method: "post",
            url: config.base_url + "Reports/GetReceiveableFeeReport",
            headers: { "Content-Type": "application/json" },
            data,
        })
            .then((response) => {
                if (response.data.status_code === 1) {
                    setLedger(response.data.ListofRecords || []);
                    setFeeTypeName(response.data.Fee_Type_Name || "");
                    setTotalFeeAmount(
                        response.data.TotalFeeAmount != null
                            ? response.data.TotalFeeAmount
                            : showReceived
                                ? response.data.TotalReceived
                                : response.data.TotalReceiveableFee
                    );
                } else {
                    setLedger([]);
                    toast.error(response.data.status_message || "No data found.");
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast.error("Network error while loading print data.");
            });
    }, []);

    const formatFeeDate = (item) => {
        const raw = item.Fee_Date || (ShowReceivedFee ? item.ReceivedDate : item.PostingDate);
        if (!raw) {
            return "-";
        }
        return moment(raw).format("DD-MMM-YYYY");
    };

    const getRowAmount = (item) => {
        if (item.FeeAmount != null) {
            return item.FeeAmount;
        }
        return ShowReceivedFee ? item.ReceivedAmount : item.ReceiveableFee;
    };

    const renderLedger = () => {
        if (listOfLedger != null && listOfLedger.length > 0) {
            let count = 1;
            return listOfLedger.map((item, index) => (
                <tr key={index}>
                    <td>{count++}</td>
                    <td>{item.Registration_No}</td>
                    <td>{item.Student_Name}</td>
                    <td>{item.Father_Name}</td>
                    <td>
                        {item.Class_Name} - {item.Section_Name}
                    </td>
                    <td>{item.Father_CNIC}</td>
                    <td>{formatFeeDate(item)}</td>
                    <td>{getRowAmount(item)}</td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan="8">
                    <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
                        No Data Found
                    </h4>
                </td>
            </tr>
        );
    };

    const reportTitle = ShowReceivedFee ? "Received Fee Report" : "Receivable Fee Report";
    const dateRange =
        StartDate && EndDate
            ? `${moment(StartDate).format("DD-MMM-YYYY")} to ${moment(EndDate).format("DD-MMM-YYYY")}`
            : "";

    return (
        <>
            <ToastContainer />
            <Page orientation="portrait" size="a4">
                <table className="table table-sm table-bordered table-print">
                    <thead>
                        <tr>
                            <th colSpan={8}>
                                <PrintHeader
                                    title={`${reportTitle}${FeeTypeName ? ` — ${FeeTypeName}` : ""}${dateRange ? ` (${dateRange})` : ""}`}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td className="text-center" colSpan="8">
                                    <Spinner animation="border" role="status" />
                                </td>
                            </tr>
                        ) : (
                            <>
                                <tr>
                                    <th className="text-end" colSpan={7}>
                                        Total {amountLabel}:
                                    </th>
                                    <th>{TotalFeeAmount}</th>
                                </tr>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Registration No</th>
                                    <th>Student Name</th>
                                    <th>Father Name</th>
                                    <th>Class Name</th>
                                    <th>Fee Head</th>
                                    <th>{dateColumnLabel}</th>
                                    <th>{amountLabel}</th>
                                </tr>
                                {renderLedger()}
                                <tr>
                                    <td colSpan={7} className="text-end">
                                        <strong>Total</strong>
                                    </td>
                                    <td>
                                        <strong>{TotalFeeAmount}</strong>
                                    </td>
                                </tr>
                            </>
                        )}
                    </tbody>
                </table>
            </Page>
        </>
    );
};

export default ReceiveableFeePrint;
